import { Component, OnInit, Input } from "@angular/core";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { first } from "rxjs/operators";
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Request } from "src/app/parametrage/core/model/request";
import { RequestItem } from "src/app/corporate/core/model/request-item";
import { Corporate } from "src/app/parametrage/core/model/corporate";
import { RequestService } from "src/app/parametrage/core/service/request.service";
import { CorporateService } from "src/app/corporate/core/service/corporate.service";
import { RequestItemService } from "src/app/corporate/core/service/request-item.service";
import { CorrectionHistoryService } from "src/app/mon-portefeuille/core/service/correction-history.service";
import { CorrectionHistory } from "src/app/mon-portefeuille/core/model/correction-history";
import { CorrigerDossier } from "src/app/mon-portefeuille/core/model/corriger-dossier";
import { RetournerDossierModalComponent } from "src/app/formulaire/modal/retourner-dossier-modal/retourner-dossier-modal.component";
import { UpdateInfoEntrepriseComponent } from "src/app/formulaire/modal/entreprise/update-info-entreprise/update-info-entreprise.component";
import { EditCreditModalComponent } from "src/app/corporate/formulaire/modal/edit-credit-modal/edit-credit-modal.component";
import { FormAddConditionComponent } from "src/app/corporate/formulaire/modal/form-add-condition/form-add-condition.component";
import { FormEditConditionComponent } from "src/app/corporate/formulaire/modal/form-edit-condition/form-edit-condition.component";
import { Condition } from "src/app/corporate/core/model/condition";
import { ConditionService } from "src/app/corporate/core/service/condition.service";

@Component({
  selector: "app-update-dossier-info",
  templateUrl: "./update-dossier-info.component.html",
  styleUrls: ["./update-dossier-info.component.scss"],

  //
  animations: [
    trigger("detailExpand", [
      state("collapsed", style({ height: "0px", minHeight: "0" })),
      state("expanded", style({ height: "*" })),
      transition(
        "expanded <=> collapsed",
        animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)")
      ),
    ]),
  ],
  //
})
export class UpdateDossierInfoComponent implements OnInit {
  form2: FormGroup;

  MyPermissions: string[];
  private userPermission = {
    permissions: [],
  };

  htmlContent = "";
  retournerDossier: String;

  corrigerDossier: CorrigerDossier;

  requestId: any;
  correctionId: string;

  items: RequestItem[];
  corporate: Corporate;
  request: Request;
  correctionHistory: CorrectionHistory;

  conditions: Condition[];
  conditionArray: Array<Condition[]> = [];
  displayedStudentsColumnsList: string[] = [
    "id",
    "produit.typeCredit.label",
    "produit.label",
    "montant",
    "actions",
  ];

  constructor(
    private _router: Router,
    private modalService: NgbModal,
    private fb: FormBuilder,
    private _requestService: RequestService,
    private _corporateService: CorporateService,
    private _requestItemService: RequestItemService,
    private _correctionHistoryService: CorrectionHistoryService,
    private _conditionService: ConditionService
  ) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      check: [null, Validators.compose([Validators.required])],
      reponse: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {
    this.requestId = this._router.url.split("/")[3];
    this.correctionId = this._router.url.split("/")[4];

    this.getCorrectionHistoryById(this.correctionId);
    this.getRequestById(this.requestId);
    this.getCorporateByRequestId(this.requestId);
    this.getListRequestItemByRequest(this.requestId);
  }

  getCorrectionHistoryById(correctionId) {
    this._correctionHistoryService
      .getCorrectionHistoryById(correctionId)
      .subscribe(
        (data) => {
          this.correctionHistory = data;
        },
        (error) => {
          console.log(error);
        }
      );
  }

  getRequestById(requestId) {
    this._requestService.getRequestById(requestId).subscribe(
      (data) => {
        this.request = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getCorporateByRequestId(requestId) {
    this._corporateService.getCorporateByRequestId(requestId).subscribe(
      (data) => {
        this.corporate = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getListRequestItemByRequest(requestId) {
    this._requestItemService.getListRequestItemByRequest(requestId).subscribe(
      (data) => {
        this.items = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  updateCustomer(corporateId) {
    const modalRef = this.modalService.open(UpdateInfoEntrepriseComponent, {
      size: "lg",
      backdrop: "static",
      centered: true,
    });
    modalRef.componentInstance.corporateId = corporateId;

    modalRef.result.then(
      (data) => {
        // on close
        this.getCorporateByRequestId(this.requestId);
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  updateCredit(requestItemId) {
    const modalRef = this.modalService.open(EditCreditModalComponent, {
      size: "lg",
      backdrop: "static",
      centered: true,
    });
    modalRef.componentInstance.requestItemId = requestItemId;
    modalRef.componentInstance.workflowCode = this.request.workflow.code;

    modalRef.result.then(
      (data) => {
        // on close
        this.getListRequestItemByRequest(this.requestId);
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  getConditionsByRequestItemId(requestitemid) {
    this._conditionService
      .getConditionsByRequestItemId(requestitemid)
      .subscribe(
        (data) => {
          this.conditions = data;
          this.conditionArray[requestitemid] = this.conditions;
        },
        (error) => {
          console.log(error);
        }
      );
  }

  AddCondition(requestItemId) {
    const modalRef = this.modalService.open(FormAddConditionComponent, {
      centered: true,
    });
    modalRef.componentInstance.requestItemId = requestItemId;

    modalRef.result.then(
      (data) => {
        // on close
        this.getConditionsByRequestItemId(requestItemId);
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  EditCondition(conditionId, requestItemId) {
    const modalRef = this.modalService.open(FormEditConditionComponent, {
      centered: true,
    });
    modalRef.componentInstance.conditionId = conditionId;

    modalRef.result.then(
      (data) => {
        // on close
        this.getConditionsByRequestItemId(requestItemId);
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  deleteCondition(conditionId, requestItemId) {
    this._conditionService
      .deleteCondition(conditionId)
      .pipe(first())
      .subscribe(
        (data) => {
          this.getConditionsByRequestItemId(requestItemId);
        },
        (error) => {
          console.log(error);
        }
      );
  }

  validUpdate(): void {
    this.corrigerDossier = new CorrigerDossier();
    this.corrigerDossier.correctionId = this.correctionId;
    this.corrigerDossier.reponse = this.htmlContent;

    this._correctionHistoryService
      .corriger(this.corrigerDossier)
      .pipe(first())
      .subscribe(
        (data) => {
          this._router.navigateByUrl("/mon-portefeuille/mes-dossiers");
        },
        (error) => {
          console.log(error);
        }
      );
  }

  retourner() {
    const modalRef = this.modalService.open(RetournerDossierModalComponent, {
      centered: true,
    });
    modalRef.componentInstance.requestId = this.correctionHistory.request.id;

    modalRef.result.then(
      (data) => {
        // on close
        this._router.navigateByUrl("/mon-portefeuille/mes-dossiers");
      },
      (reason) => {
        // on dismiss
      }
    );
  }
}
